import React, { useContext, useState } from 'react';
import { Parallax } from "react-parallax";
import { Link } from "react-router-dom";
import { AppContext } from '../main';


// const serverLocations = [
//     { title: "London, England", link: "/servers/london" },
//     { title: "Paris, France", link: "/servers/paris" },
//     { title: "Frankfurt, Germany", link: "/servers/frankfurt" },
//     { title: "Amsterdam, Netherlands", link: "/servers/amsterdam" },
//     { title: "Stockholm, Sweden", link: "/servers/stockholm" },
//     { title: "Helsinki, Finland", link: "/servers/helsinki" },
//     { title: "Los Angeles, USA", link: "/servers/los-angeles" },
// ];

const Server = (props) => {
  const {
    handleEditItem
  } = props

  const { appState
  } = useContext(AppContext);
  const { menubs = {
    menubs: [
      { title: "London, England", link: "/servers/london" },
      { title: "Paris, France", link: "/servers/paris" },
      { title: "Frankfurt, Germany", link: "/servers/frankfurt" },
      { title: "Amsterdam, Netherlands", link: "/servers/amsterdam" },
      { title: "Stockholm, Sweden", link: "/servers/stockholm" },
      { title: "Helsinki, Finland", link: "/servers/helsinki" },
      { title: "Los Angeles, USA", link: "/servers/los-angeles" },
    ]
  }
    , editMode = false } = appState


  if (!menubs?.menubs) {
    return null
  }




  return (
    <div className="container">
      {/* Server List */}
      <ul className="de-server">
        {menubs?.menubs?.map((server, index) => (
          <li key={index}>
            <Link to={server.link}>{server.title}</Link>
          </li>
        ))}
        <li>
          <Link to="/servers">View all available servers</Link>
        </li>
      </ul>
    </div>
  );
};

export default Server;
